import { styled } from 'styled-components';

import { cssBreakpoints, spacing, transition } from '#/theme/theme';

export const ViewListingPageSidebarResultsHeaderHolder = styled.header`
  padding: 0 0 ${spacing[4]} 0;
  width: 100%;
`;

export const ViewListingPageSidebarResultsHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 auto;
  max-width: 738px;
  transition: min-width ${transition};
`;

export const ViewListingPageSidebarResultsHeaderLeftSide = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const ViewListingPageSidebarResultsHeaderLeftSideSort = styled.div`
  @media all and (max-width: ${cssBreakpoints.mdDown}) {
    display: none;
  }
`;

export const ViewListingPageSidebarResultsHeaderRightSide = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
`;
